

<div class="centered">
<mat-card class="speech-bubble">
  <table style="width: 100%; padding: 0px; margin: 0px">
    <tr>
      <td class="upperTd"  >
        <div class="maherlogo"></div>
        <div class="account"></div>
        <div class="titleFont" style="padding-bottom: 10px; padding-top: 20px; text-align: center">New User </div>
        <div class="smallerFont" style="text-align: center">All Fields Marked With <mat-icon matSuffix><img style="vertical-align: center;" src="assets/check_circle-24px.svg" ></mat-icon> Are Required Fields</div>

        <div class="smallerFont" style="padding-bottom: 20px; text-align: center">If you are a new trucking company, please email Customer Support <a href="mailto:customersupport@maherterminals.com">here</a> </div>
        <form  [formGroup]="myForm" autocomplete="off"   novalidate>
          <div class="two-col">
            <div class="col1">
              <mat-form-field appearance="outline" style="width: 90%">
                <mat-label>Type Of Business</mat-label>
                <mat-select  [(value)]="businessValue" (selectionChange)="listChanged()">
                  <mat-option  *ngFor="let lr of typeOfBusiness" [value]="lr.code">{{lr.description}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col2" *ngIf="businessValue!='SHIPPER' && businessValue!='MISC'">
              <mat-form-field appearance="outline" style="width: 90%">
                <mat-label>Admin Account</mat-label>
                <mat-select  [(value)]="adminValue" >
                  <mat-option  *ngFor="let lr of yesNo" [value]="lr.code">{{lr.description}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

          </div>

          <div class="two-col">
            <div class="col1" style="padding-top: 3%">
              <mat-form-field appearance="outline" style="width: 90%"  autocomplete="off">
                <mat-label>Username</mat-label>
                <input maxlength="30" oninput="this.value = this.value.toUpperCase()" autocomplete="false" matInput formControlName="username"  [disabled]="submitted"/>
                <mat-icon matSuffix *ngIf="f.username.errors"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                <mat-icon matSuffix *ngIf="!f.username.errors"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
              </mat-form-field>
              <span *ngIf="f.username.errors" class="invalid-feedback" >
                <div class="errorDiv2" *ngIf="f.username.errors.required && submitted">Username Required</div>
                </span>
              <mat-form-field appearance="outline" style="width: 90%" >
                <mat-label>Password</mat-label>
                <input maxlength="30" [type]="activeConfirm ? 'password' : 'text'" autocomplete="false"  matInput formControlName="password" (keyup)="checkRules()" [disabled]="submitted"/>
                <div matSuffix matTooltip="show/hide password" (click)="showConfirmPassword()" class="showHide">
                  <a *ngIf="activeConfirm " >SHOW </a>
                  <a *ngIf="!activeConfirm " >HIDE </a>
                </div>

              </mat-form-field>
              <span *ngIf="f.password.errors" class="invalid-feedback">
                     <div class="errorDiv2"  *ngIf="f.password.errors.required && submitted">Password Required</div>
              </span>



            </div>

            <div class="col2 " style="text-align: -webkit-center">

            <div style="background-color:#efefef;text-align: left; padding-top: 15px; width: 90%">
              <div style="font-weight: bolder; font-size: 16px; text-align: center">Your password must contain at least:</div>
              <div class="mustContain"><mat-icon matPrefix ><img style="vertical-align: center; height: 17px" [src]="totalNum>5 ? 'assets/greenCheck.png': 'assets/troubleRed.png'"  ></mat-icon>5 or More Characters</div>
              <div class="mustContain"><mat-icon matPrefix ><img style="vertical-align: center; height: 17px" [src]="lowerFound>2 ? 'assets/greenCheck.png': 'assets/troubleRed.png'" ></mat-icon>3 Lowercase letters</div>
              <div class="mustContain"><mat-icon matPrefix ><img style="vertical-align: center; height: 17px" [src]="numberFound>0 ? 'assets/greenCheck.png': 'assets/troubleRed.png'" ></mat-icon>1 Number</div>
              <div class="mustContain"><mat-icon matPrefix ><img style="vertical-align: center;height: 17px" [src]="strangeFound>0 ? 'assets/greenCheck.png': 'assets/troubleRed.png'" ></mat-icon>1 Special Character</div>
            </div>
            </div>
          </div>



          <div class="two-col">
       <!--     <div class="col1" *ngIf="businessValue=='MISC'" >
              <mat-form-field appearance="outline" style="width: 90%" >
                <mat-label>TWIC Card Number</mat-label>
                <input maxlength="10"  oninput="this.value = this.value.toUpperCase()" matInput formControlName="twic" [disabled]="submitted"/>
                <mat-icon matSuffix *ngIf="f.twic.errors"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                <mat-icon matSuffix *ngIf="!f.twic.errors"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
              </mat-form-field>
              <span *ngIf="f.twic.errors" class="invalid-feedback">
                     <div class="errorDiv2"  *ngIf="f.twic.errors.required && submitted">TWIC Card Number Required</div>
                     <div class="errorDiv2"  *ngIf="f.twic.errors?.pattern && submitted ">TWIC Card Must Be Numeric</div>
                </span>
            </div> -->
            <div class="col1" *ngIf="businessValue=='MISC'">
              <mat-form-field appearance="outline" style="width: 90%" >
                <mat-label>Sealink Number</mat-label>
                <input maxlength="7"  oninput="this.value = this.value.toUpperCase()"  matInput formControlName="sealink" [disabled]="submitted"/>
                <mat-icon matSuffix *ngIf="f.sealink.errors"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                <mat-icon matSuffix *ngIf="!f.sealink.errors"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
              </mat-form-field>
              <span *ngIf="f.sealink.errors" class="invalid-feedback">
                     <div class="errorDiv2"  *ngIf="f.sealink.errors.required && submitted">Sealink Number Required</div>
                      <div class="errorDiv2"  *ngIf="f.sealink.errors?.pattern && submitted ">Sealink Must Be Numeric</div>
                </span>
            </div>
          </div>



          <div class="two-col">
            <div class="col1" *ngIf="businessValue!='SHIPPER' && businessValue!='MISC'" >
              <mat-form-field appearance="outline" style="width: 90%" >
                <mat-label>Existing Customer ID</mat-label>
                <input maxlength="30"  oninput="this.value = this.value.toUpperCase()" matInput formControlName="id" [disabled]="submitted"/>
                <mat-icon matSuffix *ngIf="f.id.errors"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                <mat-icon matSuffix *ngIf="!f.id.errors"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
              </mat-form-field>
              <span *ngIf="f.id.errors" class="invalid-feedback">
                     <div class="errorDiv2"  *ngIf="f.id.errors.required && submitted">Existing ID Required</div>
                </span>
            </div>
            <div class="col2" *ngIf="businessValue!='SHIPPER' && businessValue!='MISC'">
              <mat-form-field appearance="outline" style="width: 90%" >
                <mat-label>SCAC Code</mat-label>
                <input maxlength="10"  oninput="this.value = this.value.toUpperCase()" matInput formControlName="scac" [disabled]="submitted"/>
                <mat-icon matSuffix *ngIf="businessValue=='HAULIER' && f.scac.value.length==0"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                <mat-icon matSuffix *ngIf="businessValue=='HAULIER' && f.scac.value.length>0"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
              </mat-form-field>
              <div class="errorDiv2"  *ngIf="scacNoMatch && submitted">SCAC Code does not match</div>
              <div class="errorDiv2"  *ngIf="noScac && submitted">SCAC Code Mandatory</div>
            </div>
          </div>


          <div class="two-col">

            <div class="col1">
              <mat-form-field appearance="outline" style="width: 90%; ">
                <mat-label>First Name</mat-label>
                <input maxlength="30"  matInput formControlName="firstName" [disabled]="submitted" />
                <mat-icon matSuffix *ngIf="f.firstName.errors"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                <mat-icon matSuffix *ngIf="!f.firstName.errors"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
              </mat-form-field>
              <span *ngIf="f.firstName.errors" class="invalid-feedback" >
                     <div class="errorDiv2"  *ngIf="f.firstName.errors.required && submitted">First Name Required</div>
                </span>
            </div>

            <div class="col2">
              <mat-form-field appearance="outline" style="width: 90%;">
                <mat-label>Last Name</mat-label>
                <input maxlength="30"  matInput formControlName="lastName" [disabled]="submitted"/>
                <mat-icon matSuffix *ngIf="f.lastName.errors"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                <mat-icon matSuffix *ngIf="!f.lastName.errors"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
              </mat-form-field>
              <span *ngIf="f.lastName.errors" class="invalid-feedback" >
                  <div class="errorDiv2"  *ngIf="f.lastName.errors.required && submitted">Last Name Required</div>
                </span>
            </div>

          </div>




          <div class="two-col">

            <div class="col1">
              <mat-form-field appearance="outline" style="width: 90%;">
                <mat-label>Phone Number: (999) 999-9999</mat-label>

                <input matInput id="tel" phoneMask [preValue]="myForm.value.phone"  [phoneControl]="myForm.controls['phone']" formControlName="phone" maxlength="14"  [disabled]="submitted" />
                <mat-icon matSuffix *ngIf="f.phone.errors"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                <mat-icon matSuffix *ngIf="!f.phone.errors"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
              </mat-form-field>
              <span *ngIf="f.phone.errors" class="invalid-feedback">
                  <div class="errorDiv2"  *ngIf="f.phone.errors.required && submitted">Phone Number Required</div>
                </span>
            </div>


            <div class="col2">
              <mat-form-field appearance="outline" style="width: 90%;">
                <mat-label>Email Address</mat-label>

                <input maxlength="50"  matInput formControlName="email" [disabled]="submitted"/>
                <mat-icon matSuffix *ngIf="f.email.errors"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                <mat-icon matSuffix *ngIf="!f.email.errors"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
              </mat-form-field>
              <span *ngIf="f.email.errors" class="invalid-feedback">
                  <div class="errorDiv2"  *ngIf="f.email.errors.required && submitted">Email Address Required</div>
                </span>
            </div>
          </div>


          <table style="width: 100%">
            <tr>
              <td style="alignment: center">

                <div class="errorDiv2" style="font-size: 17px" *ngIf="maherError!='' && submitted">{{maherError}}</div>
                <div class="errorDiv2" style="font-size: 17px" *ngIf="navisErrors!='' && submitted">{{navisErrors}}</div>
                <div class="errorDiv2" style="font-size: 17px" *ngIf="badAdmin && submitted">Contact your System Administrator to setup your account</div>
                <div class="errorDiv2" style="font-size: 17px" *ngIf="!allSatisfied && submitted">Password Requirments Not Met</div>

              </td>
            </tr>
          </table>


        </form>
        <div style="padding-top: 5%; text-align: center">
          <button mat-raised-button class="blueButton"  (click)="createNewUser()" style="padding-bottom: 5px" color="primary">Create New User</button>
        </div>
        <div class="div-forgot" style="text-align: center; padding-bottom: 10px; padding-top: 30px; color: #E61E00" (click)="returnBack()">Return To Login </div>
      </td>

      <td class="lowerTd daPic">
      </td>
    </tr>
  </table>
</mat-card>
</div>

